import * as React from 'react';
import { AlertDangerStyle } from './Style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';

type AlertDangerProps = {
  show: boolean;
  message: string | JSX.Element;
  showIcon?: boolean;
  onClose?: () => void;
};

const AlertDanger: React.FunctionComponent<AlertDangerProps> = ({
  show,
  message,
  showIcon = true,
  onClose,
}): JSX.Element => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const closeAlert = (): void => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <React.Fragment>
      {visible && (
        <AlertDangerStyle>
          {showIcon && (
            <FontAwesomeIcon
              className="alert-icon"
              icon={faExclamationTriangle}
            />
          )}
          <span>{message}</span>
          <button onClick={closeAlert}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </AlertDangerStyle>
      )}
    </React.Fragment>
  );
};

export default AlertDanger;
